export const getVirtualStatus = (game) => {
  if (!game) return "";

  // If status is technically in-progress but start time is in the future
  if (game.status === "in-progress" && game.start_datetime) {
    const startTime = new Date(
      game.start_datetime.endsWith("Z")
        ? game.start_datetime
        : `${game.start_datetime}Z`,
    ).getTime();
    if (startTime > Date.now()) {
      return "upcoming";
    }
  }
  return game.status;
};
